import type { FaireProductEntity } from "../../entity_types/product";

export const p_yw5f98scww: FaireProductEntity = {
  token: "p_yw5f98scww",
  type: "product",
  name: "Pocket Heroes Oracle Deck",
  brandToken: "b_bomzcs63",
  brandName: "Hachette Book Group",
  imageUrl: "https://cdn.faire.com/fastly/46a5fab41eaa81e71920afd7bfadf9c629bfc0f1ff7a01e1f940374af22d2aed.jpeg",
  galleryImageUrls: [],
  priceDollars: 10,
  description: "This fun & feisty oracle deck features wisdom, wit, and helpful action steps from 50 iconic pop culture heroes—and classic memes—like Simone Biles, Frida Kahlo, and Kermit Drinking Tea. Just pick an iconic card, reflect on the iconic shit it says, and learn to love the hell outta your iconic self and others. Brought to you by the bestselling creator of the Spiritual AF line, Roxan McDonald. Get epic wisdom, daily chuckles—and an inspirational pocket hug 24/7! Not your grandma’s oracle cards (unless your grandma was a meme-lovin’ badass)! 3.75 x 5 inches; 50 cards, plus 60 page guidebook.",
  tags: [],
  msrpDollars: 19.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:06:53.691Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
